import React from 'react';
import LinesSVG from '@/assets/svg/lines.svg?react';
import { Mask, Container, SvgContainer } from './styles';

export const Background: React.FC = () => (
	<Container>
		<Mask />
		<SvgContainer>
			<LinesSVG />
		</SvgContainer>
	</Container>
);
